// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const modelsClient = createTypedClient();
export const createModelsClient = (config) => createTypedClient(config);
